import React from "react";
import { fullDownloadTaskFilePath } from "../../api";
import { getFileName } from "../genericUtils";

const DownloadButton = ({
  fileObject,
  downloadName = "",
  onClick = () => {},
  className = "",
  style = {},
  children,
}) => {
  const triggerDownload = () => {
    const filePath = fullDownloadTaskFilePath + fileObject.id;
    downloadName = downloadName ? downloadName : getFileName(fileObject.file);

    const link = document.createElement("a");
    link.href = filePath; // URL to the backend download endpoint
    link.download = downloadName; // Optionally, specify the downloaded file name
    document.body.appendChild(link);
    link.click(); // Simulate the click to trigger download
    document.body.removeChild(link); // Clean up by removing the link
    onClick();
  };

  return (
    <>
      <button
        className={className}
        style={style}
        title="Scarica"
        onClick={triggerDownload}
      >
        {children}
      </button>
    </>
  );
};

export default DownloadButton;
